/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-04-07 12:53:13
 * @LastEditors: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @LastEditTime: 2024-06-22 13:23:51
 * @FilePath: \website\src\components\element\attrs\cpt-richtxt-option.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
    cptDataForm: {
        dataText: '{"value":"<div style=color:#fff;letter-spacing:2px;text-indent:2em;>以城市供水行业内部综合管理系统为基础，建立供水行业内部综合的企业信息管理系统解决方案。为企业建立统一信息平台、建立企业信息门户，部署应用整合架构，规范流程与各项流程电子化。完成企业信息传递与知识共享，提高办事效率，提高领导决策及时性、科学性和准确性，提高企业综合管理水平。</div>"}',
        dataSource: 1,
        pollTime: 0,
        apiUrl: '/text',
        sql: 'select id from test limit 1'
    },
    attribute: {
        cptTableData: [{ "name": "值", "value": "", "namekey": "value" }],
        defaultValueType: null,
        defaultValue: '',
        label: '标题：',
        labelBoolean:true,
        disabled:false,
        disabledColor:'#eee',
        readonly:false,
        labelAlign:'right',
        labelWidth:100,
        placeholder: '请输入',
        size: 'medium', 
        width:144,
        height:300,
        autosize:false,
        isScroll:false,
        xScroll:false,
        yScroll:false,
        
        align:"left",
        indent:10,
        maxlength:9999,
        bgColor: '#00000000',
        textColor: '#fff',
        textPlaceholderColor: '#333',
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontFamily: '微软雅黑',
        fontSize: 12,
        textColor: '#ffffff',
        borderSize: 1,
        borderColor: '#333333',
        borderRadius: 0,
        lineType: 'solid',
        required: false,
        parentId: '',
        panelBg:'#00000000',
        activeBgColor: '#2684ff',
        activeColor: '#2684ff',
        disableColor:'#ffffff',
        disableBg:'#00000000',
        bg:'#00000000',
        panelNum:'',
        activeNum: '',
        activeNum: '',
        disableBool:false,
        disableBool:false,
        bgBool:false,
    },
    interaction: { eventText: '完成输入时' }
}